import { useEffect, useRef, useState } from 'react';
import { SVG_GENERATION_PROMPT } from '../../../symbols/svgHelp';

export function SvgHelp({ onBack }: { readonly onBack: () => void }) {
  const back = useRef<HTMLButtonElement>(null);
  const prompt = useRef<HTMLTextAreaElement>(null);
  const [feedback, setFeedback] = useState('');
  useEffect(() => back.current?.focus(), []);
  return (
    <div className="symbol-svg-help">
      <h2>SVG help</h2>
      <p>Import local artwork directly. Your SVG stays in this project; no hosting is needed.</p>
      <ul>
        <li>Use static paths, common shapes, solid fills/strokes, groups and static transforms.</li>
        <li>
          Include a usable viewBox or width/height. Transparency and multiple solid colours work.
        </li>
        <li>
          Compatible monochrome SVGs can be tinted. Multicolour artwork keeps its original colours.
        </li>
      </ul>
      <p>
        Filters, gradients, clipping, embedded images, animation, linked resources and stylesheets
        are unsupported. Export a simplified SVG or transparent PNG for complex artwork.
      </p>
      <details>
        <summary>Generate icon with AI model</summary>
        <p>
          Use this prompt in the AI chat model of your choice to generate an icon for Placeio.
          Replace [DESCRIBE SYMBOL] and check the result before importing; compatibility is not
          guaranteed.
        </p>
        <textarea
          ref={prompt}
          aria-label="SVG generation prompt"
          readOnly
          rows={8}
          value={SVG_GENERATION_PROMPT}
        />
      </details>
      <div className="symbol-svg-help-actions">
        <button
          className="secondary-button"
          type="button"
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(SVG_GENERATION_PROMPT);
              setFeedback('AI icon prompt copied.');
            } catch {
              prompt.current?.closest('details')?.setAttribute('open', '');
              prompt.current?.focus();
              prompt.current?.select();
              setFeedback('Select the prompt and copy it with your keyboard.');
            }
          }}
        >
          Copy AI icon prompt
        </button>
        <button ref={back} className="secondary-button" type="button" onClick={onBack}>
          Back to symbols
        </button>
      </div>
      <p role="status" className="style-help">
        {feedback}
      </p>
    </div>
  );
}
